import { useRef, useState, useEffect } from 'react';

type SortProps = {
  items: string[];
  value: number;
  onChange: (index: number) => void;
};

function Sort({ items, value, onChange }: SortProps) {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const sortRef = useRef<HTMLDivElement>(null);

  const handleSelect = (i: number) => {
    onChange(i);
    setIsVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (e: PointerEvent) => {
      const el = sortRef.current;
      if (!el) {
        return;
      }
      if (!el.contains(e.target as Node)) {
        setIsVisible(false);
      }
    };

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsVisible(false);
      }
    };

    document.body.addEventListener('pointerdown', handleClickOutside);
    document.body.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <div className="sort" ref={sortRef}>
      <div className="sort__label" onClick={() => setIsVisible(!isVisible)}>
        <svg
          className={`sort__arrow ${isVisible ? 'sort__arrow--up' : 'sort__arrow--down'}`}
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z"
            fill="#2C2C2C"
          />
        </svg>

        <b>Sort by:</b>
        <span>{items[value]}</span>
      </div>
      {isVisible && (
        <div className="sort__popup">
          <ul>
            {items.map((item, i) => (
              <li
                key={item}
                className={value === i ? 'active' : ''}
                onClick={() => handleSelect(i)}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Sort;
